// bao migrate skip
import TabPage from "./../../factories/tab-page";
import BaoDialog from "./../../factories/bao-dialog";
import Bao from "./../../services/bao-service";
import * as ko from "knockout";
import GenericListTabHistory from "./../../factories/generic-list-tab-history";
class ServiceComponentViewModel extends GenericListTabHistory {
    ConfigurationItem: any;
    Years: KnockoutObservableArray<Number> = ko.observableArray([]);
    Months: KnockoutObservableArray<Number> = ko.observableArray([]);
    SelectedYear: KnockoutObservable<Number> = ko.observable(null);
    SelectedMonth: KnockoutObservable<Number> = ko.observable(null);
    OnlyUpcomingServiceComponents: KnockoutObservable<Boolean> = ko.observable(true);
    ShowDeletedServiceComponents: KnockoutObservable<Boolean> = ko.observable(false);
    BillingTypeName: KnockoutObservable<String> = ko.observable("");
    BillingTypeId: KnockoutObservableArray<String> = ko.observableArray([]);
    BillingRhythmName: KnockoutObservable<String> = ko.observable("");
    BillingRhythmId: KnockoutObservableArray<String> = ko.observableArray([]);
    DatabaseRefresh: Boolean = true;
    initInProgress: Boolean = true;
    constructor(public TabPage: TabPage, parent: any) {
        super(TabPage, parent);
        this.DialogWidth = 400;
        this.ConfigurationItem = parent;
        this.SelectedYear.subscribe(() => { this.RefreshList(); });
        this.SelectedMonth.subscribe(() => { this.RefreshList(); });
        this.OnlyUpcomingServiceComponents.subscribe(() => { this.RefreshList(); });
        this.ShowDeletedServiceComponents.subscribe(() => { this.RefreshList(); });
        this.BillingTypeId.subscribe(() => { this.RefreshList(); });
        this.BillingRhythmId.subscribe(() => { this.RefreshList(); });
    }
    RefreshList() {
        if (!this.initInProgress) {
            if (this.TabPage.DirtyFlag()) {
                return;
            }
            if (this.PageIndex() != 0) {
                this.PageIndex(0);
            }
            this.DatabaseRefresh = true;
            this.Get();
        }
    }
    Refresh() {
        return super.Refresh().then(() => { this.TabPage.DirtyFlag(false); });
    }
    ;
    Dialog(id: string): JQueryPromise<void> {
        this.TabPage.IsLoading(true);
        return Bao.post(this.UrlDialog(), JSON.stringify({
            sessionTabId: this.SessionTabId,
            parentId: ko.unwrap(this.Parent.PrimaryKeyValue),
            id: id
        }), (result: Factories.GenericListResponse.DialogResponse) => {
            var dialog = new BaoDialog(Bao.Session.ApplicationName);
            var okButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgOk"), () => {
                var item = dialog.ViewModel();
                delete item.Parent;
                this.ItemCompleteCheck.call(this, item).then((validateResult) => {
                    if (validateResult) {
                        this.TabPage.DirtyFlag(true);
                        this.Save(ko.map.toJS(item)).then(() => {
                            dialog.Close();
                        });
                    }
                });
            });
            var cancelButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {
                dialog.Close();
            });
            if (this.DialogWidth != null) {
                dialog.Width(this.DialogWidth + "px");
            }
            dialog.Buttons([okButton, cancelButton]);
            dialog.Template(result.Template);
            var vm = ko.map.fromJS(result.Model);
            vm.Parent = this;
            dialog.ViewModel(vm);
            dialog.Open(null);
            this.TabPage.IsLoading(false);
        });
    }
    Remove(itemIds: string[]): JQueryPromise<void> {
        var def = $.Deferred<void>();
        this.TabPage.IsLoading(true);
        Bao.post(this.UrlRemove(), JSON.stringify({
            sessionTabId: this.SessionTabId,
            ids: itemIds
        }), () => {
            this.TabPage.DirtyFlag(true);
            this.Get().then(() => {
                def.resolve();
            });
        });
        return def.promise();
    }
    CustomFilter() {
        var customFilterHashObject = [];
        if (this.SelectedYear() != null) {
            var hashObjectYear: any = {};
            hashObjectYear.Key = 'BillingYear';
            hashObjectYear.Value = this.SelectedYear();
            customFilterHashObject.push(hashObjectYear);
            var hashObjectMonth: any = {};
            hashObjectMonth.Key = 'BillingMonth';
            hashObjectMonth.Value = this.SelectedMonth();
            customFilterHashObject.push(hashObjectMonth);
            var hashObjectOnlyUpcomingServiceComponents: any = {};
            hashObjectOnlyUpcomingServiceComponents.Key = 'OnlyUpcomingServiceComponents';
            hashObjectOnlyUpcomingServiceComponents.Value = this.OnlyUpcomingServiceComponents();
            customFilterHashObject.push(hashObjectOnlyUpcomingServiceComponents);
            var hashObjectShowDeletedServiceComponents: any = {};
            hashObjectShowDeletedServiceComponents.Key = 'ShowDeletedServiceComponents';
            hashObjectShowDeletedServiceComponents.Value = this.ShowDeletedServiceComponents();
            customFilterHashObject.push(hashObjectShowDeletedServiceComponents);
            var hashObjectBillingTypeId: any = {};
            hashObjectBillingTypeId.Key = 'BillingTypeId';
            hashObjectBillingTypeId.Value = JSON.stringify(this.BillingTypeId());
            customFilterHashObject.push(hashObjectBillingTypeId);
            var hashObjectBillingRhythmId: any = {};
            hashObjectBillingRhythmId.Key = 'BillingRhythmId';
            hashObjectBillingRhythmId.Value = JSON.stringify(this.BillingRhythmId());
            customFilterHashObject.push(hashObjectBillingRhythmId);
            var hashObjectIsDirty: any = {};
            hashObjectIsDirty.Key = 'IsDirty';
            hashObjectIsDirty.Value = this.TabPage.DirtyFlag();
            customFilterHashObject.push(hashObjectIsDirty);
            this.DatabaseRefresh = false;
        }
        return customFilterHashObject;
    }
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise();
    }
    public Edit(item) {
        if (item != null) {
            this.Dialog(ko.unwrap(item.PrimaryKeyValue));
        }
    }
    ToggleToolbarButtons() {
        ko.utils.arrayForEach(this.ToolbarButtons(), (button) => {
            var key = ko.unwrap(button.ActionKey);
            var enabled = <KnockoutObservable<boolean>>(button.Enabled);
            if (key == this.PermissionEdit) {
                enabled(false);
                if (this.Selection() != null && this.Selection().length == 1) {
                    if (!this.Selection()[0].IsDeleted) {
                        enabled(true);
                    }
                }
                //enabled(this.Selection() != null && this.Selection().length == 1);
            }
            else if (key == this.PermissionRemove) {
                enabled(false);
                if (this.Selection() != null && this.Selection().length == 1) {
                    if (!this.Selection()[0].IsDeleted) {
                        enabled(true);
                    }
                }
            }
        });
    }
    Get(resetIndex = true): JQueryPromise<void> {
        var def = $.Deferred<void>();
        if (this["_refreshInProgress"] == false) {
            this["_refreshInProgress"] = true;
            if (resetIndex) {
                this.PageIndex(0);
            }
            this.TabPage.IsLoading(true);
            Bao.post(this.UrlGet(), JSON.stringify({
                sessionTabId: this.SessionTabId,
                parentId: this.GetParentId(),
                customFilter: this.CustomFilter(),
                sorting: this.Sorting(), pageIndex: this.PageIndex(),
                pageSize: this.PageSize()
            }), (result: Factories.GenericListResponse.GetResponse) => {
                // reset selection, when list is reloading!
                this.Selection([]);
                this.Models(result.Models);
                this.TotalRows(result.TotalRows);
            }).always(() => {
                this["_refreshInProgress"] = false;
                this.TabPage.IsLoading(false);
                def.resolve();
            });
        }
        else {
            def.resolve();
        }
        return def.promise();
    }
    loadFilter() {
        this.TabPage.IsLoading(true);
        return Bao.post("SynosetMasterData/GetYearCollection", JSON.stringify({}), (result) => {
            var DatumAkt = new Date();
            var JahrAkt = DatumAkt.getFullYear();
            for (var r in result) {
                if (result[r].Key != "" && result[r].Key != null)
                    this.Years.push(result[r].Key);
            }
            this.SelectedYear(JahrAkt);
        }).then(() => {
            return Bao.post("SynosetMasterData/GetMonthCollection", JSON.stringify({}), (result) => {
                var DatumAkt = new Date();
                var monthAkt = DatumAkt.getMonth();
                for (var r in result) {
                    if (result[r].Key != "" && result[r].Key != null)
                        this.Months.push(result[r].Key);
                }
                this.SelectedMonth(monthAkt + 1);
            }).then(() => {
                this.TabPage.IsLoading(false);
            });
        });
    }
    
    loaded() {
        this.initInProgress = false;
        this.RefreshList();        
    }

    init() {
        var def = $.Deferred<any>();
        super.init().then(() => {
            this.loadFilter().then(() => {
                //this.Refresh().then(() => {
                def.resolve();
                //});
            });
        });
        return def.promise();
    }
}
export default ServiceComponentViewModel;